import { GenericCollectionFactory } from "../_generics";
import { GENERIC_IDS } from "../_constants/generics.constants";

export const MobilesStore = GenericCollectionFactory(GENERIC_IDS.MOBILES, "uid");